import { defineStore } from "pinia"
import { fetchTransactionData } from "@/api/transaction"
import { executeWithdrawFunds } from "@/api/transaction"
import { getUserTransaction } from "@/api/transaction"
import { fetchWithdrawalRequests } from "@/api/transaction"

export const useTransactStore = defineStore("transaction", {
  state: () => ({
    transactions: [],
    usertransaction: null,
    walletTr: [],
    withdraws: [],
  }),

  actions: {
    async loadTransaction() {
      const res = await fetchTransactionData()
      this.transactions = res.data.data
    },
    async loadUserTransaction(id) {
      const res = await getUserTransaction(id)
      this.usertransaction = res.data.data
    },
    async loadWithdrawalRequests() {
      const res = await fetchWithdrawalRequests()
      this.withdraws = res.data.data
    },
    async withdrawFunds(){
      const res = await executeWithdrawFunds()
      this.withdraw = res.data.data
    }
  }
})
